export const START_FETCHING_DRIVERS = 'START_FETCHING_DRIVERS';
export const FETCHING_DRIVERS_SUCCESS = 'FETCHING_DRIVERS_SUCCESS';
export const FETCHING_DRIVERS_ERROR = 'FETCHING_DRIVERS_ERROR';

const startFetchingDrivers = () => {
  return {
    type: START_FETCHING_DRIVERS,
  };
};

const doneFetchingDrivers = drivers => {
  return {
    type: FETCHING_DRIVERS_SUCCESS,
    drivers,
  };
};

const errorFetchingDrivers = () => {
  return {
    type: FETCHING_DRIVERS_ERROR,
  };
};

export const fetchDrivers = (dealerId, lat, lon) => (dispatch, getState, { api }) => {
  dispatch(startFetchingDrivers());

  return api
    .fetchDrivers(dealerId, lat, lon)
    .then(drivers => dispatch(doneFetchingDrivers(drivers)))
    .catch(e => {
      dispatch(errorFetchingDrivers());

      throw new Error(e);
    });
};



// WEBPACK FOOTER //
// ./src/actions/api-drivers.js